import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

/* Themed replacement for window.confirm / window.prompt.
   Props:
     title, message        — content
     confirmLabel          — button text (default "Confirm")
     danger                — red confirm button
     withReason            — show a reason textarea
     reasonRequired        — block confirm until non-empty
     reasonLabel, reasonPlaceholder, defaultReason
     onConfirm(reason)     — called on confirm
     onClose               — called on cancel/backdrop/Esc               */
export default function ConfirmModal({
  title, message, confirmLabel, danger,
  withReason, reasonRequired, reasonLabel, reasonPlaceholder, defaultReason,
  onConfirm, onClose
}) {
  const [reason, setReason] = useState(defaultReason || '');
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const blocked = withReason && reasonRequired && !reason.trim();

  const confirm = () => {
    if (blocked) { setTouched(true); return; }
    onConfirm(reason.trim());
  };

  return ReactDOM.createPortal(
    <div className="ng-modal-backdrop" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="ng-modal cm-modal" role="dialog" aria-modal="true">
        <div className="ng-modal-header">
          <h5 className="ng-modal-title">{title}</h5>
          <button type="button" className="ng-modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="ng-modal-body">
          {message ? <p className="cm-message">{message}</p> : null}
          {withReason ? (
            <div className="sh-field" style={{ marginTop: message ? 14 : 0 }}>
              <label>
                {reasonLabel || 'Reason'}
                {reasonRequired ? null : <span style={{ fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}> (optional)</span>}
              </label>
              <textarea
                rows="3"
                autoFocus
                placeholder={reasonPlaceholder || ''}
                value={reason}
                onChange={e => setReason(e.target.value)}
              />
              {touched && blocked ? <span className="cm-required">A reason is required.</span> : null}
            </div>
          ) : null}
        </div>
        <div className="ng-modal-footer cm-footer">
          <button type="button" className="sh-btn sh-btn-outline" onClick={onClose}>
            Never mind
          </button>
          <button
            type="button"
            className={'sh-btn ' + (danger ? 'cm-btn-danger' : 'sh-btn-primary')}
            onClick={confirm}
          >
            {confirmLabel || 'Confirm'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
